import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { TWO_DECIMAL_PLACES } from '../../../../constants/constants';

@Component({
    selector: 'aumico-number-input',
    styleUrls: ['./aumico-number-input.scss'],
    templateUrl: './aumico-number-input.html',
})
export class AumicoNumberInputComponent {
    @Input() decimalPlaces = TWO_DECIMAL_PLACES;
    @Input() placeholder: string | undefined;
    @Input() allowNegative = true;
    @Input() control: UntypedFormControl = new UntypedFormControl();
    @Input() disabled: boolean = false;
    @Input() required: boolean = false;
    @Input() errorStateMatcher: ErrorStateMatcher | undefined;
}
